import { createContext, useContext } from 'react'

import { ConfigWithCallbacks } from '@root/types/config'
import { ConfigWithCallbacks as SizeAdvConfigWithCallbacks } from '@root/types/sizeadvisorconfig'

export const ConfigContext = createContext({} as ConfigWithCallbacks | SizeAdvConfigWithCallbacks)

export const useConfig = () => useContext(ConfigContext)
